import {
    instance as axios,
    setJwtToken,
  } from "../../config/axiosInstance";
  
export const pumpFeedingListApi = async (data) => {
  const endPoint = `admin/pump-feeding/list?${new URLSearchParams(
    data
  ).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
